"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
require("../assets/styles/order.css");
function Order(props) {
    var _a = (0, react_1.useState)(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.Box, { className: "ordercomp" },
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Owner: ",
                    props.userId),
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Date: ",
                    props.createdAt),
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Price: ",
                    props.amountPaid),
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", color: "primary" },
                    "status: ",
                    props.status),
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Button, { variant: "outlined", "aria-label": "more", id: "long-button", "aria-controls": open ? "long-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: handleClick }, "Products"),
                    react_1.default.createElement(material_1.Menu, { id: "long-menu", MenuListProps: {
                            "aria-labelledby": "long-button",
                        }, anchorEl: anchorEl, open: open, onClose: handleClose }, props.orderProducts.map(function (product) {
                        return (react_1.default.createElement(material_1.MenuItem, { key: product.productId, onClick: function () {
                                handleClose();
                            } },
                            product.productName,
                            ": ",
                            product.productQuantity,
                            " X $",
                            product.price));
                    })))),
            react_1.default.createElement(material_1.Divider, null))));
}
exports.default = Order;
